import { createAsyncAction, createAction } from 'redux-promise-middleware-actions';
import { addAsyncActionPostfixes } from '../utils/actionTypeCreator';
import api from '../api/apiSettings';

export const types = {
  ...addAsyncActionPostfixes({
    SAVE_USER_DATA: 'SAVE_USER_DATA',
    FETCH_USER_DATA: 'FETCH_USER_DATA',
    SAVE_USER_LOCATION: 'SAVE_USER_LOCATION',
    SET_USER_INDUSTRIES: 'SET_USER_INDUSTRIES',
    SET_USER_FUNCTIONS: 'SET_USER_FUNCTIONS',
    SAVE_USER_RATES: 'SAVE_USER_RATES',
    SET_USER_CONSENT: 'SET_USER_CONSENT',
    SAVE_PERSONAL_DATA: 'SAVE_PERSONAL_DATA',
    SAVE_CONTRACT_TYPE: 'SAVE_CONTRACT_TYPE',
    SAVE_WORK_HISTORY: 'SAVE_WORK_HISTORY',
    SWITCH_JOB_SEEKING: 'SWITCH_JOB_SEEKING',
    CREATE_NEW_WORK_HISTORY: 'CREATE_NEW_WORK_HISTORY'
  }),
  UPDATE_USER_DATA: 'UPDATE_USER_DATA',
  TEMPO_SAVE_JOB: 'TEMPO_SAVE_JOB',
  SYNC_UPDATE_WORK: 'SYNC_UPDATE_WORK',
  SYNC_ADD_WORK: 'SYNC_ADD_WORK',
  SYNC_DELETE_WORK: 'SYNC_DELETE_WORK'
};

export const tempoSaveJob = createAction(types.TEMPO_SAVE_JOB, (data) => {
  localStorage.setItem('tempoSavedJob', JSON.stringify(data));
  return data;
});

export const saveUserData = createAsyncAction(types.SAVE_USER_DATA, (userId, data) =>
  api.put(`v1/user/${userId}`, data).then((res) => res.data)
);

export const savePersonalData = createAsyncAction(types.SAVE_PERSONAL_DATA, (userId, data) =>
  api.put(`v1/user/personal-details/${userId}`, data).then(() => data)
);

export const fetchUserData = createAsyncAction(types.FETCH_USER_DATA, (userId) =>
  api.get(`v1/user/${userId}`).then((res) => res.data)
);

export const initUserData = createAction(types.UPDATE_USER_DATA, (data) => data);

export const updateExistingWork = createAction(types.SYNC_UPDATE_WORK, (data) => data);

export const addNewWork = createAction(types.SYNC_ADD_WORK, (data) => data);

export const deleteExistingWork = createAction(types.SYNC_DELETE_WORK, (data) => data);

export const saveUserRates = createAsyncAction(types.SAVE_USER_RATES, (userId, data) =>
  api.put(`v1/user/${userId}/user-rates`, data).then(() => data)
);

export const saveJobLocation = createAsyncAction(types.SAVE_USER_LOCATION, (userId, data) =>
  api.put(`v1/user/${userId}/job-location`, data).then((res) => res.data)
);

export const saveContractType = createAsyncAction(types.SAVE_CONTRACT_TYPE, (userId, data) =>
  api.put(`v1/user/${userId}/contract-type`, data).then((res) => res.data)
);

export const setIndustries = createAsyncAction(types.SET_USER_INDUSTRIES, (userId, data, dataForStore) =>
  api.put(`v1/user/${userId}/industries`, data).then(() => dataForStore)
);

export const setFunctions = createAsyncAction(types.SET_USER_FUNCTIONS, (userId, data, dataForStore) =>
  api.put(`v1/user/${userId}/job-functions`, data).then(() => dataForStore)
);

export const manageConsent = createAsyncAction(types.SET_USER_CONSENT, (userId, data) =>
  api.put(`v1/user/${userId}/manage-consent?IsRevoke=${data}`).then(() => data)
);

export const saveWorkHistory = createAsyncAction(types.SAVE_WORK_HISTORY, (jobID, data) =>
  api.put(`v1/work-history/${jobID}`, data).then((res) => res.data)
);

export const switchJobSeeking = createAsyncAction(types.SWITCH_JOB_SEEKING, (userId, isSeeking) =>
  api.put(`v1/user/is-job-seeking/${userId}?IsJobSeeking=${isSeeking}`).then(() => isSeeking)
);

export const createNewWorkHistory = createAsyncAction(types.CREATE_NEW_WORK_HISTORY, (data) =>
  api.post(`v1/work-history`, data).then((res) => res.data)
);
